import type { LookoRouteObject } from '../LookoRouteObject';
import { productMap } from '../productMap';

// 상품관리
const productRoutes: LookoRouteObject[] = [
  {
    path: productMap['origin-list'].path,
    async lazy() {
      const { default: Page } = await import('@/app/products/origin-list/OriginListPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: productMap['edit-item'].path,
    async lazy() {
      const { default: Page } = await import('@/app/products/edit-item/SaleItemEditPage');
      return {
        Component: Page,
      };
    },
  },
];

export default productRoutes;
